<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" :style="($store.state.currentLocation.state == 'TAS') ? { width: '80%' } : { width: '30%'}">
                <div class="modal-header">
                    <slot name="header">
                        <h3 class="form-header">Administration</h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style='padding: 0'></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <!-- action="{{ url('payment') }}" -->
                        <!-- aria-label="{{ __('PaymentSubmit') }}" -->
                        <form class="action-modal">

                            <!-- BASIC INFO -->
                            <!-- BASIC INFO -->
                            <div class="form-section-container" style="grid-template-columns: 1fr; width: 100%; padding-left: 0;">

                                <!-- <div class="left-form-section-panel">
                            <div>
                                <p class="note-header">Notes</p>
                                <textarea style="border-top-left-radius: 0; border-top-right-radius: 0; width: 100%;" name="notes" id="note-modal" cols="23" rows="20" placeholder="Enter notes here..." v-model="form.submit.notes"></textarea>
                            </div>
                        </div> -->

                                <!-- RIGHT SIDE PANEL -->
                                <div class="right-form-section-panel" style="display: flex; flex-direction: column;">
                                    <!-- BEFORE THEY CHOOSE IMPREST OR PATIENT OWNED MEDS -->
                                    <div v-if="patient && patient.personal_information && patient.regulatory_information"
                                        class="individual-patient-container">
                                        <!-- <div class="patient-result-image" style="width: 100px; height: 100px; background-color: salmon">

                                </div> -->
                                        <div class="patient-result-info">
                                            <p><b>Name:</b> {{ patient.personal_information.first_name }}
                                                {{ patient.personal_information.last_name }}</p>
                                            <p><b>Medicare Number:</b> {{ patient.regulatory_information && patient.regulatory_information.length ? patient.regulatory_information[0].data : 'N/A' }}</p>
                                            <p><b>DOB:</b> {{ patient.personal_information ?
                                                    patient.personal_information.dob : ''
                                            }}</p>
                                            <p><b>Location:</b> {{ patient.physical_location &&
                                                    patient.physical_location.location ?
                                                    patient.physical_location.location.name : ''
                                            }}</p>
                                        </div>
                                    </div>
                                    <div v-if="patient">
                                        <div style="display: flex; margin-bottom: 10px;" :style="!selectedPrescriber ? {alignItems: 'flex-end'}:{alignItems: 'center'}">
                                            <div v-if="!selectedPrescriber"
                                                class="text-search-container search-container text-field"
                                                style="display: flex; flex-direction: column; margin-top: 0.25em; margin-right: 20px;  position: relative;">
                                                <label for="first_name"
                                                    style="text-align: left; padding-left: 10px">Search for
                                                    Prescriber</label>
                                                <input v-model="gp" v-on:keyup="debounceGpSearch(gp)" v-on:keyup.enter="debounceGpSearch.clear(), gpSearch(gp)"
                                                    placeholder="Enter Prescriber No. or Name"
                                                    style="position: relative; border: 3px solid rgb(202, 202, 202); background-color: white;" />
                                                <div class="drug-search-result-container" v-if="gp"
                                                    style="position: absolute; margin-top: 55px; background-color: white; width: 20em; border: 2px solid #f6f6f6; z-index:9">
                                                    <p class="drug-search-result"
                                                        style="text-align: left; padding-left: 20px; cursor:pointer"
                                                        v-for="(item, index) in prescriberResults" :key="index"
                                                        @click="selectPrescriber(item)">{{ item.regulatory_numbers.length
                                                                ? item.regulatory_numbers[0].data : 'Reference only'
                                                        }} - {{ item.first_name }}
                                                        {{ item.last_name }}</p>
                                                </div>
                                                
                                            </div>
                                            <div v-if="!selectedPrescriber" style="margin-bottom: 2px;">
                                                <p class="blue-button" style="margin: 0; font-size: 1em;" @click="displayReferencePrescriberModal = true">Create prescriber</p>
                                            </div>
                                            <div v-if="selectedPrescriber"
                                                style="display: grid; grid-template-columns: 1fr 1fr; grid-gap: 2em; margin-right: 15px;">
                                                <p style="font-size: 0.9em; text-align: left;"><b>Prescriber:</b>
                                                    {{ selectedPrescriber.first_name }} {{ selectedPrescriber.last_name }}
                                                </p>
                                                <p style="font-size: 0.9em" v-if="selectedPrescriber.prescriber_no"><b>Prescriber Number:
                                                    </b>{{ selectedPrescriber.prescriber_no }}</p>
                                            </div>
                                            <p style="text-align: left;  cursor:pointer; width: fit-content;
                                        border-bottom: 1px solid grey; margin-top: 0; height: fit-content"
                                                v-if="selectedPrescriber.uuid" @click="changePrescriber()">Change
                                                Prescriber</p>
                                        </div>
                                    </div>

                                    <div v-if="!patient">
                                        <div class="right-form-section-drug-entry">
                                            <div
                                                style="width: 100%; display: grid; grid-template-columns: 1fr; grid-gap: 10px;">
                                                <p @click="() => {displayPatientSearchModal = true }"
                                                    :style="($store.state.currentLocation.state == 'TAS') ? { width: '50%', margin: '0 auto', marginTop: '2em' } : { width: '70%', margin: '0 auto', marginTop: '2em' }"
                                                    class="pom-imprest-choice-button">
                                                    Search for {{ $resident({ capitalize: true }) }}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="!patient" class="resident-help-note">
                                        Before handling stock, please choose the {{ $resident({ lowercase: true }) }} it belongs to.
                                    </div>

                                    <div v-if="(!$store.state.currentLocation?.facility?.medication_movement_default || $store.state.currentLocation?.facility?.medication_movement_default === 0) && (!imprest_pom || !form.submit.drugs.length) && patient">
                                        <p
                                            style="margin: 0; padding: 0; padding-bottom: 10px; font-size: 0.95em; text-align: left;">
                                            Please select whether this is imprest/emergency meds/ward stock or {{ $resident({ lowercase: true }) }} medication.</p>
                                        <div class="right-form-section-drug-entry">
                                            <div class="pom-imprest-select">
                                                <p @click="() => { imprest_pom = 'pom';}"
                                                    v-bind:class="[imprest_pom == 'pom' ? 'active-select-filter' : '']"
                                                    class="pom-imprest-choice-button">
                                                    {{ $resident({ capitalize: true }) }} Medication</p>

                                                <p @click="() => { imprest_pom = 'imprest'; }"
                                                    v-bind:class="[imprest_pom == 'imprest' ? 'active-select-filter' : '']"
                                                    class="pom-imprest-choice-button">
                                                    Imprest/Emergency Meds/Ward Stock</p>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="right-form-section-drug-entry" v-if="imprest_pom == 'imprest'">
                                        <!-- Both dropdowns share the row on explicit proportions. A fixed width on the
                                             medication picker pushed the quantity off the modal, because a flex item will not
                                             shrink below its content; a bare `flex: 1` then handed the row to the batch
                                             dropdown, which sizes itself at 100% of whatever contains it. Two thirds
                                             medication, one third batch, quantity fixed. -->
                                        <div :style="($store.state.currentLocation.state == 'TAS') ? { width: '100%', marginRight: '10px' } : { display: 'flex', alignItems: 'center', flex: '2 1 0', minWidth: 0, marginRight: '10px' }">
                                            <!-- <Dropdown v-model="stock" ref="med" @change="drugSelect(stock), show()" @keyup="searchDrugs(stock), show()" :loading="loadingDrugs" :options="drugList" optionLabel="full_name" :editable="true"
                                            style="width: 25em; display: flex" optionDisabled="disabled" placeholder="Type medication name here"/> -->
                                            <Dropdown
                                                v-model="stock"
                                                ref="med" @keyup="debounceSearchDrugs(stock), show()"
                                                @focus="onDrugFocus"
                                                :loading="loadingDrugs"
                                                :options="drugList"
                                                optionLabel="full_name"
                                                optionDisabled="disabled"
                                                :editable="true"
                                                :emptyMessage="stockPickerEmptyMessage(stock)"
                                                style="width: 100%; display: flex"
                                                placeholder="Select Medication"
                                            />
                                        </div>
                                        <!-- Only present when there is a batch to choose, so the row gives the whole width to
                                             the medication picker on unbatched stock. -->
                                        <div v-if="stockHasBatches" style="display: flex; align-items: center; flex: 1 1 0; min-width: 0;">
                                            <BatchSelect :stockItem="stock" v-model="selectedBatch" />
                                        </div>
                                        <input
                                            v-model="qty"
                                            type="number"
                                            placeholder="Qty"
                                            style="position: relative; width: 6em; flex: none; margin-left: 10px; margin-right: 10px;"
                                            @change="() => { if (qty && !batchRequiredAndMissing) { aliasSelect(stock) }}" />
                                    </div>
                                    <!-- PATIENT MEDICATION SEARCH.
                                         No batch dropdown here: a resident's own supply comes off
                                         their stock register, which carries no batches - kraken's
                                         StockItemPatientResource does not return them. -->
                                    <div v-if="loadingDrugs && imprest_pom != 'imprest'">
                                        <i class="pi pi-spin pi-spinner"
                                            style="font-size: 2rem !important;margin-top: 2em;"></i>
                                    </div>
                                    <div class="right-form-section-drug-entry"
                                        v-if="patient && !loadingDrugs && imprest_pom == 'pom'">
                                        <div style="width: 100%; margin-right: 10px">

                                            <Dropdown
                                                v-model="stock"
                                                ref="med" 
                                                @input="show()"
                                                :loading="loadingDrugs"
                                                :options="patientMeds"
                                                optionLabel="full_name"
                                                optionDisabled="disabled"
                                                :editable="false"
                                                :filter="true"
                                                filterPlaceholder="Search medication"
                                                :filterFields="['alias.generic_name', 'alias.name']"
                                                :emptyMessage="`No medications held for this ${$resident({ lowercase: true })}.`"
                                                emptyFilterMessage="No medications found for that search."
                                                style="width: 100%; text-align: left; display: flex" placeholder="Select Medication"
                                            />
                                        </div>

                                        <input 
                                            v-model="qty" 
                                            type="number" 
                                            placeholder="Quantity"
                                            style="position: relative; width: 30%; margin-right: 10px;" 
                                            @change="() => { if (qty && stock) { aliasSelect(stock) }}"
                                        />
                                    </div>


                                    <div class="right-form-section-drug-container" v-if="patient">
                                        <table style="border-collapse: collapse">
                                            <tr>
                                                <th >Medication Name</th>
                                                <th >Stock Qty</th>
                                                <th >Supplied</th>
                                                <th >Remaining Qty</th>
                                                <th v-if="$store.state.currentLocation.state == 'TAS'">Count</th>
                                                <th v-if="$store.state.currentLocation.state == 'TAS'" style="width: 80px">Diff</th>
                                                <th v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: center">Confirm</th>
                                                <th></th>
                                            </tr>
                                            <template v-for="(item, index) in form.submit.drugs" :key="index">
                                            <tr class="drug-entry-transfer">
                                                <td style="width: 50%;">
                                                    <p style="font-size: 1em;">{{ item.stock }}</p>
                                                </td>
                                                <td style="text-align: center">
                                                    <p>{{ item.qty_left }}</p>
                                                </td>
                                                <td style="text-align: center">
                                                    <p>{{ item.entered_qty }}</p>
                                                </td>
                                                <td style="text-align: center">
                                                    <span :class="(item.qty_left - item.entered_qty) < 0 ? 's8-tag' : ''">{{ item.qty_left - item.entered_qty }}</span>
                                                </td>
                                                <td v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: left">
                                                    <input style="width: 8em; background-color: white;" v-model="item.qty_remaining" type="number" min="0" @input="onQtyRemainingChange(item)" />
                                                </td>
                                                <td v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: left">
                                                    <span :class="(item.qty_remaining - (item.qty_left - item.entered_qty) >= 0) ? 'green-tag' : 's8-tag'">{{ item.qty_remaining - (item.qty_left - item.entered_qty) }}</span>
                                                </td>
                                                <td v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: center; width: 40px">
                                                    <Checkbox :binary="true" v-model="item.qty_remain_confirmed"/>
                                                </td>
                                                <!-- <td v-if="!removedDrug">
                                            <p class="blue-button" style="font-weight: 500; padding: 5px 10px; text-align: center; margin-right: 10px;" @click="removeDrugReg(item)">Remove from Register</p>
                                        </td>
                                        <td v-else>
                                            <div style="display: flex" v-if="item.administered === true || (item.administered != false && !item.doc)">
                                                <div  @click="item.administered = true" style="cursor: pointer;height: 20px; width: 20px; border-radius: 50%; border: 1.5px solid green; margin-right: 10px;" :style="[item.administered === true ? {backgroundColor: 'green'}:{}]"></div>
                                                <div @click="item.administered = false" style="cursor: pointer;height: 20px; width: 20px; border-radius: 50%; border: 1.5px solid #E04F39"></div>
                                            </div>
                                            
                                            <div v-if="item.administered === false" style="width: 70px" class="doc-select-container">
                                                <select name="DOC" id="doc-admin" @change="selectDOC(item)" :style="item.status ? {backgroundColor: '#E04F39', color: 'white'}:{backgroundColor: '#E5E8EA'}"
                                                style="padding: 10px;width: 70px;border-radius: 20px;">
                                                    <option value="" disabled selected>DOC</option>
                                                    <option v-for="(reason, listIndex) in doseOmittedCode" :key="listIndex" :value="reason">{{reason}}</option>
                                                </select>
                                            </div>
                                        </td> -->
                                                <td>
                                                    <div>
                                                        <p @click="removeDrug(index)"
                                                            class="red-close-button small-button">
                                                            <i class="pi pi-times" style="padding: 0"></i>
                                                        </p>
                                                    </div>
                                                </td>

                                            </tr>
                                            <tr class="drug-entry-transfer"
                                                v-if="$store.state.currentLocation.state != 'WA' && rowHasRemainder(item)">
                                                <td>
                                                    <p style="font-size: 1em;">Remainder:</p>
                                                </td>
                                                <td><input type="number" min="0"
                                                        :max="item.stock_quantity"
                                                        style="background-color: white; width: 10em"
                                                        v-model="item.discard_amount"
                                                        :placeholder="rowDifference(item)">
                                                </td>

                                                <td>
                                                    <div style="display: flex;">
                                                        <Checkbox :inputId="'discard-' + index" v-model="item.discard" :binary="true"
                                                            style="margin-right: 5px;" />
                                                        <label :for="'discard-' + index"
                                                            style="margin-right: 10px; white-space: pre">Discard Remainder</label>
                                                    </div>

                                                </td>
                                                <td></td>
                                            </tr>
                                            <tr class="drug-entry-transfer"
                                                v-if="$store.state.currentLocation.state == 'WA'">
                                                <td style="padding-left: 15px; width: 22em;">
                                                    <p style="font-size: 1em; padding:5px">Administered:</p>
                                                    <input type="number" min="0"
                                                        v-model="item.wa_administered"
                                                        style="background-color: white; width: 10em; margin-right: 5px;"
                                                        placeholder="Amount">
                                                        <Dropdown
                                                            :inputId="'dose-unit-administered-' + index"
                                                            placeholder="Dose Unit"
                                                            :options="item.dose_types"
                                                            v-model="item.dose_unit"
                                                        />
                                                </td>
                                                <td style="padding-left: 15px;">
                                                    <p style="font-size: 1em; padding:5px">Discarded:</p>
                                                    <input type="number" min="0"
                                                        v-model="item.wa_discarded"
                                                        style="background-color: white; width: 10em; margin-right: 5px;"
                                                        placeholder="Amount">
                                                        <Dropdown
                                                            :inputId="'dose-unit-discarded-' + index"
                                                            placeholder="Dose Unit"
                                                            :options="item.dose_types"
                                                            v-model="item.dose_unit"
                                                        />
                                                </td>
                                            </tr>
                                            </template>
                                            <tr v-if="hasNegativeRemaining">
                                                <td colspan="8" style="text-align: left; color: #E04F39; font-size: 0.9em; padding-top: 5px">
                                                    Supplied quantity is above the recorded stock balance. Check the physical stock before completing.
                                                </td>
                                            </tr>
                                            </table>
                                    </div>
                                    <div v-if="patient && form.submit.drugs.length" style="display: flex; align-items: center; margin-top: 10px;">
                                        <Checkbox inputId="record-administration" v-model="recordAdministration" :binary="true" style="margin-right: 8px;" />
                                        <!-- No position modifier, so the tooltip's own custom properties can be set here. A
                                             max-content tooltip centred on this label runs past the left edge of the modal, and
                                             .modal-container scrolls, so anything outside it is clipped. Fixed width and
                                             left-aligned growth keeps it inside. -->
                                        <label for="record-administration" style="font-size: 0.95em; text-align: left; cursor: pointer; --v-tooltip-left: 0%; --v-tooltip-translate: translate(0, -110%); --v-tooltip-width: 18rem;"
                                            v-tooltip="'Adds the administration lines to the register in addition to the drug safe removal lines'">
                                            Record Administration in Register
                                        </label>
                                    </div>
                                    <div v-if="errorMessage">
                                        <p style="color: red; font-weight: 500; font-size: 1em;">{{ errorMessage }}</p>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </slot>
                </div>

                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px;">
                    <slot name="footer" style="display: flex;">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px;" @click="closeModal">Cancel
                        </p>
                        <p class="regular-button complete-button" style="margin-right: 10px;"
                            v-if="patient && form.submit.drugs.length" @click="removeDrugReg()">
                            Complete</p>
                        <!-- <p class="regular-button complete-button" v-if="patient && form.submit.drugs.length"
                            @click="removeDrugReg(form.submit.drugs[0]), addNew = true">Complete + New</p> -->
                    </slot>
                </div>
            </div>
        </div>
        <PatientSearchModal @close="close" v-if="displayPatientSearchModal" @patient="getPatient" />
        <ReferencePrescriberModal @close="close" v-if="displayReferencePrescriberModal" @prescriber="getPrescriber" />
        <SignatureModal v-if="displaySignatureModal" :drugReg="drugReg" :notes="notes" :payload="payload" :saveContext="saveContext"
            :displaySaveContext='$store.state.currentLocation.state == "WA"'
            :payload2="payload2" @isSuccessful="isSuccessful" @close="close" :endpoint="endpoint" :endpoint2="endpoint2" @drugSafeRetrievalId="drugSafeRetrievalId"
            @partialComplete="partialComplete"
            dual="true" :sequential_loop="true" :item_labels="itemLabels" :sequential_follow_up="sequentialFollowUp" />
    </div>
</template>

<script>
import SignatureModal from '@/components/modals/SignatureModal.vue';
import PatientSearchModal from '@/components/modals/PatientSearchModal.vue';
import ReferencePrescriberModal from '@/components/modals/ReferencePrescriberModal.vue';
import axios from 'axios';
import { isPickerEmpty, pickerSearchTerm, stockPickerEmptyMessage } from '@/services/pickers';
import { searchIndexes } from '@/services/algoliaSearch';
import { debounce, debounceSearch, DEFAULT_DEBOUNCE_MS } from '@/services/debounce';
import { decorateStockItems } from '@/services/stockItemDisplay';
import BatchSelect from '@/components/BatchSelect.vue';

export default {
    components: {
        BatchSelect,
        SignatureModal,
        PatientSearchModal,
        ReferencePrescriberModal
    },
    data() {
        return {
            // Assigned in created() rather than declared in methods - see services/debounce.js.
            debounceGpSearch: null,
            displayReferencePrescriberModal: false,
            saveContext:{
                notes: ''
            },
            endpoint: '',
            endpoint2: '',
            // The second request per medication: the administration that follows the register removal.
            // Null when the nurse turns off "Record Administration in Register".
            sequentialFollowUp: null,
            // On by default - giving the dose is the point of the removal, so the administration line is
            // the normal case and leaving it out is the exception.
            recordAdministration: true,
            drugReg: [],
            notes: false,
            loadingDrugs: false,
            payload: '',
            payload2: '',
            removedDrug: false,
            imprest_pom: '',
            defaultApplied: false,
            pom: '',
            patient: '',
            gp: '',
            prescriberResults: [],
            addNew: false,
            patientMeds: [],
            prescriber: '',
            selectedPrescriber: '',
            displaySignatureModal: false,
            displayPatientSearchModal: false,
            newLoc: '',
            stock: '',
            reasonCat: '',
            reasonSubCat: '',
            errorMessage: '',
            qty: null,
            aliasId: '',
            drugList:[],
            // The batch the dose is being given from, where the stock has batches. BatchSelect clears it
            // whenever the medication changes.
            selectedBatch: null,
            doseOmittedCode: [
                'A',
                'F',
                'H',
                'L',
                'S',
                'S/A',
                'V',
                'A/T',
                'C',
                'N',
                'N/R',
                'O',
                'R',
                'W',
                'W/R'
            ],
            form: {
                submit: {
                    prescriber_uuid: '',
                    patient_id: '',
                    notes: '',
                    drugs: [],
                    doc: '',
                    administered: '',
                    chart_id: '',

                }
            }
        };
    },
    watch: {
        imprest_pom: {
            handler(newVal) {
                if (newVal === '') {
                    if (this.defaultApplied) return;
                    const movementDefault = this.$store.state.currentLocation?.facility?.medication_movement_default;
                    if (movementDefault === 1) {
                        this.imprest_pom = 'imprest';
                        this.defaultApplied = true;
                    } else if (movementDefault === 2) {
                        this.imprest_pom = 'pom';
                        this.defaultApplied = true;
                    }
                }
            },
            immediate: true
        },
        // The row is added from the quantity input's change event. On batched stock the nurse
        // usually types the quantity first, by which point that event has already fired and been
        // refused for the missing batch - so picking the batch has to be able to add the row too,
        // or nothing happens until they go back and re-edit the quantity.
        selectedBatch(batch) {
            if (batch && this.qty && !this.batchRequiredAndMissing) {
                this.aliasSelect(this.stock);
            }
        }
    },
    created() {
        this.debounceGpSearch = debounceSearch((query) => this.gpSearch(query));
    },
    methods: {
        stockPickerEmptyMessage,
        // Returns the dose units for one medication. Held on the row rather than on the modal - with
        // several meds in the set, a single modal-level list showed the last drug picked against all of
        // them.
        doseTypesFor(drug){
            if (drug.alias.form == 'Patch') {
                return ['Patch'];
            }
            // Lower cased before matching: the picker capitalises the first letter of every name,
            // so "Drops ..." never matched and those medications fell through to the generic list.
            const drugName = (drug.alias.name || '').toLowerCase();
            if (drugName.includes('drop')) {
                return ['drop'];
            }
            if (drugName.includes('cream') || drugName.includes('ointment') || drugName.includes('gel')) {
                return ['application'];
            }

            const doseTypes = [
                drug.alias.form,
                drug.alias.measurement_unit.split('/')[0]
            ];

            if (drug.alias.measurement_unit.split('/')[1] != 'each') {
                doseTypes.push(drug.alias.measurement_unit.split('/')[1]);
            }

            return doseTypes;
        },
        drugSafeRetrievalId(value){
            if(value){
                console.log('this is the drug safe retrieval id in quick admin', value);
                // this.form.submit.drug_safe_retrieval = value;
                // this.submitAdmin();
                this.$emit('close', true, 'success');
            }
        },
        // Administration always comes out of stock the location actually holds, so this only
        // ever searches stock items - there is no drug catalogue lookup to fall back on.
        // fetchDefault is the focus preload: an empty term lists the whole holding.
        searchDrugs(fetchDefault = false) {
            const searchTerm = pickerSearchTerm(this.stock);
            if (!searchTerm && !fetchDefault) return;

            this.loadingDrugs = true;
            axios.post('/get-stock-items', { drug: searchTerm }, this.$store.state.header).then(res => {
                this.$store.dispatch('getRefreshToken');
                this.drugList = decorateStockItems(res.data);
                this.errorMessage = '';
            }).catch(err => {
                if (err.response && err.response.data && typeof err.response.data === 'string' && err.response.data.split(' ').includes('expired')) {
                    this.$router.push('/login');
                }
                this.errorMessage = (err.response && err.response.data) ? err.response.data : 'Failed to search medications. Please try again.';
            }).finally(() => {
                this.loadingDrugs = false;
            })
        },
        debounceSearchDrugs: debounce(function () {
            this.searchDrugs();
        }, DEFAULT_DEBOUNCE_MS),
        // Clicking into an empty picker shows what the location holds, rather than nothing.
        onDrugFocus() {
            if (isPickerEmpty(this.stock)) {
                this.searchDrugs(true);
                this.show();
            }
        },
        show(){
            console.log('HITING SAVE FUNCTION');
            let interval = setInterval(() => {
                console.log('HITTING INTERVAL');
                if (!this.loadingDrugs && this.drugList) {
                    clearInterval(interval);
                    this.$refs.med.show();
                }
            }, 100)
        },
        
        getPrescriber(value){
            console.log('getprescriber function is called', value);
            if(value){
                this.selectedPrescriber = value;
                this.displayReferencePrescriberModal = false;
            }
            
        },
        selectDOC(drug) {
            drug.status = document.getElementById(`doc-admin`).value;
            console.log('this is the drug doc and object', drug.status, drug);
        },
        gpSearch(prescriber) {
            // let results = [];
            this.prescriberResults = [];
            console.log('this is the drug', prescriber);
            searchIndexes(this.$store.state, [
                { "indexName": `${this.$store.state.subdomain}_prescribers`, "params":  `query=${prescriber}` },
                { "indexName": `${this.$store.state.subdomain}_prescriber_references`, "params":  `query=${prescriber}&facetFilters=company_uuid:${this.$store.state.company.uuid}` },
            ]).then(res => {
                    console.log('this is the algolia res', res.data.results);
                    res.data.results.forEach(indexResult=>{
                        console.log('these are the results for this particular index', indexResult);
                        if(indexResult.hits.length){

                            // results.push(indexResult.hits);
                            indexResult.hits.forEach(hit=>{
                                this.prescriberResults.push(hit);
                            })
                            console.log('this is the local results varaible', this.prescriberResults);
                        }
                        
                    })
                    // this.prescriberResults = res.data.hits;
                    // state.commit('setDrugNames', res.data.hits);
                })
                // Algolia gives up after 5s per host (see services/algoliaSearch.js). On a bad
                // connection that rejection had nothing catching it; the dropdown just stays empty.
                .catch(err => {
                    console.log('prescriber search failed', err);
                })

        },
        // One /drug-safe-retrieval body per medication in the set. SignatureModal takes the array, the
        // nurse signs once, and it posts them one at a time.
        removeDrugReg() {
            this.errorMessage = '';

            const invalidRow = this.firstInvalidRow();
            if (invalidRow) {
                this.errorMessage = invalidRow;
                return;
            }

            this.drugReg = this.form.submit.drugs;
            this.notes = true;
            this.endpoint = '/drug-safe-retrieval';

            this.payload = this.form.submit.drugs.map(drug => {
                const submission = {
                    quantity: (drug.qty).toString(),
                    stock_item_id: drug.drug,
                    batch_uuid: drug.batch_uuid ?? null,
                    prescriber_uuid: this.selectedPrescriber.uuid,
                    patient_id: this.patient.uuid,
                    notes: '',
                };

                if (this.$store.state.currentLocation.state == 'TAS') {
                    submission.balance_confirmed = drug.qty_remain_confirmed;
                    submission.actual_balance = (drug.qty_remaining).toString();
                }

                if (this.$store.state.currentLocation.state == 'WA') {
                    submission.notes = `[ADMINISTERED- ${drug.wa_administered} ${drug.dose_unit}] - [DISCARDED - ${drug.wa_discarded + ' ' + drug.dose_unit + '.'}]`;
                }

                return submission;
            });

            // The administration that follows each removal. The retrieval is the register movement; this is
            // the record of the dose reaching the patient, and kraken skips the stock deduction when a
            // retrieval is attached. SignatureModal fills in `drug_safe_retrieval` from the uuid the
            // retrieval returns.
            this.sequentialFollowUp = this.recordAdministration ? {
                endpoint: '/administer-standalone',
                response_key: 'drug_safe_retrieval',
                payloads: this.form.submit.drugs.map(drug => ({
                    patient_id: this.patient.uuid,
                    stock_item_id: drug.drug,
                    dose: (drug.qty).toString(),
                    batch_uuid: drug.batch_uuid ?? null,
                    notes: this.$store.state.currentLocation.state == 'WA'
                        ? `${drug.stock} has been administered ${drug.wa_administered}${drug.dose_unit}${drug.wa_discarded ? '. Discarded amount: ' + drug.wa_discarded + ' ' + drug.dose_unit : '.'}`
                        : ''
                }))
            } : null;

            if (this.$store.state.currentLocation.state == 'WA') {
                this.saveContext.notes = this.form.submit.drugs
                    .map(drug => `${drug.stock}: [ADMINISTERED- ${drug.wa_administered} ${drug.dose_unit}] - [DISCARDED - ${drug.wa_discarded + ' ' + drug.dose_unit + '.'}]`)
                    .join('\n');
            }

            // Every row that discards its remainder goes out on one movement - the endpoint takes a drugs
            // array, and one register line reads better than one per medication.
            // Ticked, still a partial dose, and an actual amount to discard. A row whose quantity was
            // edited back to a whole number after ticking would otherwise send a zero discard.
            const discardRows = this.form.submit.drugs.filter(drug => drug.discard && this.rowHasRemainder(drug) && Number(this.discardQty(drug)) > 0);

            if (this.$store.state.currentLocation.state != 'WA' && discardRows.length) {
                this.endpoint2 = `/location/${this.$store.state.currentLocation.uuid}/outgoing`;
                this.payload2 = {
                    notes: 'Discarding administration remainder for ' + this.patient.personal_information.first_name + ' ' + this.patient.personal_information.last_name + ': '
                        + discardRows.map(drug => `${drug.stock} ${this.discardQty(drug)}`).join(', '),
                    drugs: discardRows.map(drug => ({
                        drug: drug.drug,
                        qty: this.discardQty(drug),
                        // Required per row where the stock item holds batches - the discard comes off the
                        // same batch as the dose.
                        batch_uuid: drug.batch_uuid ?? null
                    })),
                    lost_damaged: 'discard',
                    prescriber_uuid: this.selectedPrescriber.uuid,
                    patient_uuid: this.imprest_pom != 'imprest' ? this.patient.uuid : ''
                };
            } else {
                this.endpoint2 = '';
                this.payload2 = '';
            }

            this.removedDrug = true;
            this.displaySignatureModal = true;
        },
        // Part of the set was recorded and part was not. Anything whose stock has already moved comes off
        // the list, whether or not its administration was recorded - resubmitting those rows would take
        // the dose off the register a second time.
        partialComplete(result) {
            if (!result) return;

            const firstStageOnly = result.firstStageOnly || [];
            const settled = [...(result.recorded || []), ...firstStageOnly];
            if (!settled.length) return;

            const removedFromRegisterOnly = firstStageOnly.map(index => this.form.submit.drugs[index]?.stock).filter(Boolean);

            [...settled].sort((a, b) => b - a).forEach(index => {
                this.form.submit.drugs.splice(index, 1);
            });

            this.errorMessage = removedFromRegisterOnly.length
                ? `Removed from the register without an administration recorded: ${removedFromRegisterOnly.join(', ')}. Record the administration from the register before giving anything else.`
                : 'Some medications were not recorded. The ones that were have been removed from the list.';
        },
        discardQty(drug) {
            return drug.discard_amount ? drug.discard_amount : this.rowDifference(drug);
        },
        // The first thing stopping the set being submitted, or null. Reported per medication because with
        // several rows a single modal-level message does not say which one is wrong.
        firstInvalidRow() {
            if (!this.patient) return 'A ' + this.$resident({ lowercase: true }) + ' must be chosen.';
            if (!this.form.submit.drugs.length) return 'A drug must be added into this submission.';
            if (!this.selectedPrescriber || !this.selectedPrescriber.uuid) return 'A prescriber must be chosen.';

            const isWA = this.$store.state.currentLocation.state == 'WA';

            for (const drug of this.form.submit.drugs) {
                if (!drug.qty || Number(drug.qty) <= 0) {
                    return `${drug.stock}: enter a quantity.`;
                }
                if (isWA && (!drug.wa_administered || !drug.dose_unit || isNaN(drug.wa_discarded) || drug.wa_discarded === null || drug.wa_discarded === '')) {
                    return `${drug.stock}: administered and discarded values and dose unit must be filled in.`;
                }
            }

            return null;
        },
        closeModal() {
            console.log('hitting this closemodal function')
            this.$emit('close', true);
            if (this.imprest_pom != 'imprest' && !this.patient) {
                this.displayPatientSearchModal = false;
                this.imprest_pom = '';
            }
        },
        closeLocationModal(value) {
            if (value) {
                this.addNewLocation = false;
            }
        },
        close(value) {
            if (value) {
                this.displaySignatureModal = false;
                this.displayReferencePrescriberModal=false;
                if (this.imprest_pom != 'imprest' && !this.patient) {
                    this.displayPatientSearchModal = false;
                    this.imprest_pom = '';
                }
            }
        },
        isSuccessful(value) {
            if (value) {
                if (!this.addNew) {
                    console.log('this is the value returned', value);
                    this.$emit('close', true, 'success');
                }
                else {
                    if (this.drugReg.length) {
                        this.removedDrug = true;
                    }
                    // this.form.submit.drugs = [];
                }
                
            }
        },
        getPatient(value) {
            if (value) {
                this.patient = value;
                this.displayPatientSearchModal = false;
                this.loadingDrugs = true;
                axios.post(`/person/${this.patient.uuid}/stock-register`, {}, this.$store.state.header).then(res => {
                    console.log('this is the patient register', res);
                    this.patientMeds = decorateStockItems(Array.isArray(res.data) ? res.data : []);
                    this.errorMessage = '';
                }).catch(err=>{
                    console.log('this is the error', err);
                    this.errorMessage = (err.response && err.response.data) ? err.response.data : 'Failed to load medications. Please try again.';
                }).finally(()=>{
                    this.loadingDrugs = false;
                })
            }
        },
        addToPending() {
            this.form.submit.pending = !this.form.submit.pending;
        }, 
        // The part of the dose left in the container, per row.
        rowDifference(item) {
            return Math.abs(Math.ceil(item.entered_qty) - item.entered_qty);
        },
        // A partial dose out of a holding larger than the dose - so there is a remainder to discard.
        rowHasRemainder(item) {
            const held = Number(item.stock_quantity != null ? item.stock_quantity : item.qty_left);
            return !Number.isInteger(Number(item.qty)) && held > Number(item.qty);
        },
        onQtyRemainingChange(item) {
            console.log('Quantity remaining changed:', item.qty_remaining);
            item.qty_remain_confirmed = (Number(item.qty_remaining) == (Number(item.qty_left) - Number(item.entered_qty))) ? true : false;
        },
        aliasSelect(item) {
            // `stock` starts as an empty string, so entering a quantity before picking a
            // medication arrives here with nothing to add. Both branches below read
            // `item.alias`, which threw and lost the row the nurse had just typed.
            if (!item || !item.alias) return;
            // Rows are pushed, not unshifted, so the table reads in the order the meds were entered and
            // the submission order matches what the nurse sees.
            if (this.imprest_pom != 'imprest') {
                this.form.submit.drugs.push({
                    stock: item.alias.name,
                    form: item.alias.form,
                    entered_qty: this.qty,
                    stock_quantity: item.quantity,
                    drug: item.uuid,
                    // Post the entered quantity, not the balance. Clamping here made an
                    // over-administration silently record the available balance instead of
                    // failing DrugSafeImprestCheck the way imprest already does.
                    qty: this.qty,
                    qty_left: Number(item.quantity),
                    batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                    // Per row, because the set can hold several meds with different forms and each one
                    // carries its own discard and its own WA amounts.
                    alias_id: item.alias.alias_id,
                    dose_types: this.doseTypesFor(item),
                    dose_unit: '',
                    discard: false,
                    discard_amount: '',
                    wa_administered: null,
                    wa_discarded: null,
                });
            } else {
                this.form.submit.drugs.push({
                    stock: item.alias.name,
                    form: item.alias.form,
                    drug: item.uuid,
                    entered_qty: this.qty,
                    stock_quantity: item.quantity,
                    qty: this.qty,
                    qty_left: Number(item.qty_left),
                    batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                    alias_id: item.alias.alias_id,
                    dose_types: this.doseTypesFor(item),
                    dose_unit: '',
                    discard: false,
                    discard_amount: '',
                    wa_administered: null,
                    wa_discarded: null,
                });
            }

            const added = this.form.submit.drugs[this.form.submit.drugs.length - 1];

            if(this.$store.state.currentLocation.state == 'TAS') {
                added.qty_remain_confirmed = true;
                added.qty_remaining = Number(added.qty_left) - Number(added.qty)
            }

            this.aliasId = item.alias.alias_id;
            this.qty = null;
            this.stock = '';
            this.selectedBatch = null;
        },
        removeDrug(index) {
            console.log('this is the index', index, this.form.submit.drugs);
            console.log('this is the stock', this.stock);
            this.stock = '';
            this.form.submit.drugs.splice(index, 1);
        },
        submitAdmin() {
            this.drugReg = [];
            console.log('this is the submitAdmin func being called')
            if (this.patient && this.form.submit.drugs.length) {
                setTimeout(()=>{
                    this.payload = {
                        patient_id: this.patient.uuid,
                        drug_safe_retrieval: this.form.submit.drug_safe_retrieval ? this.form.submit.drug_safe_retrieval: '',
                        dose: (this.form.submit.drugs[0].entered_qty).toString(),
                        notes:'',
                        stock_item_id:this.form.submit.drugs[0].drug,
                        // Which batch the dose came from. Null where the stock holds no batches.
                        batch_uuid: this.form.submit.drugs[0].batch_uuid ?? null,
                    }
                    this.notes = true;
                    this.endpoint = '/administer-standalone';
                    // Single medication only, and unreachable while nothing calls this. Reads the first
                    // row's own discard and WA values, which is where those fields now live.
                    const row = this.form.submit.drugs[0];
                    if (row.discard) {
                        console.log('this is the current location', `/location/${this.$store.state.currentLocation.uuid}/outgoing`)
                        this.endpoint2 = `/location/${this.$store.state.currentLocation.uuid}/outgoing`;
                        this.payload2 = {
                            notes: 'Discarding administration remainder: ' + row.discard_amount + ' else,[' + ((Number(row.stock_quantity) > 1 ? 1 : Number(row.stock_quantity).toFixed(2)) - Number(row.qty).toFixed(2)) + ']',
                            drugs: [
                                {
                                    drug: this.aliasId,
                                    qty: row.discard_amount ? Number(row.discard_amount) : ((Number(row.stock_quantity) > 1 ? 1 : Number(row.stock_quantity).toFixed(2)) - Number(row.qty).toFixed(2))
                                }
                            ],
                            lost_damaged: 'discard',
                            prescriber_uuid: this.selectedPrescriber.uuid,
                            patient_uuid: this.patient.uuid
                        }
                    }
                    if(row.wa_administered){
                        this.payload.notes = `${row.stock} has been administered ${row.wa_administered}${row.dose_unit} ${row.wa_discarded ? ' Discarded amount: '+row.wa_discarded+' '+row.dose_unit :'.'}`
                    }
                    if(this.$store.state.currentLocation.state != 'WA'){
                        this.displaySignatureModal = true;
                    } else{
                        if(!row.wa_administered || !row.dose_unit){
                            this.errorMessage = 'Administered value and dose unit must be filled in.'
                        }
                    }
                    
                    this.errorMessage = '';
                },100)
                
            } else {
                this.errorMessage = 'A drug must be added into this submission.'
            }
            console.log('this is the form to submit', this.form);
        },
        selectPrescriber(prescriber) {
            this.prescriberResults = [];
            this.selectedPrescriber = {
                prescriber_no: prescriber.regulatory_numbers.length ? prescriber.regulatory_numbers[0].data : '',
                uuid: prescriber.uuid,
                first_name: prescriber.first_name,
                last_name: prescriber.last_name,
                phone: prescriber.phone,
                after_hours: prescriber.after_hours,
                address: prescriber.address,
                email: prescriber.email,
                fax: prescriber.fax,
                primary_gp: false
            }
        },
        changePrescriber() {
            this.selectedPrescriber = '';
            this.gp = '';
        },
    },
    mounted() {
    },
    computed:{
        // The stock holds batches and none has been chosen, so the dose cannot be recorded against a
        // batch yet. The backend accepts a missing batch, so this is the only place the choice is
        // required - the alternative is a dose that leaves the batch amount overstated.
        batchRequiredAndMissing() {
            return this.stockHasBatches && !this.selectedBatch;
        },
        // Whether the selected stock offers a batch to choose. The feature flag is checked here too, so a
        // stale response carrying batches cannot leave Add permanently disabled for a facility that has no
        // batch dropdown to satisfy it with.
        stockHasBatches() {
            const batches = (this.stock && Array.isArray(this.stock.batches)) ? this.stock.batches : [];
            return this.$store.getters.isBatchTrackingEnabled && batches.length > 0;
        },
        // Names for the signature modal's progress line and its per-medication summary, in payload order.
        itemLabels() {
            return this.form.submit.drugs.map(drug => `${drug.stock} x ${drug.qty}`);
        },
        // Warning only - submission stays open so the server rejects it and the
        // discrepancy is surfaced rather than absorbed.
        hasNegativeRemaining() {
            return this.form.submit.drugs.some(function (drug) {
                return (Number(drug.qty_left) - Number(drug.entered_qty)) < 0;
            });
        }
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

 

  


.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}

 

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}

.selected-hollow-button {
    background-color: $strongblue;
    color: white;
}
</style>
